import styled from 'styled-components';

export const TagBadge = styled.span`
  margin-left: 6px;
  padding: 2px 6px;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  background: #00a889;
  color: #ffffff !important;
  border-radius: 4px;
`;
